import { alpha, Dialog, DialogContent, Stack, Typography, useTheme } from '@mui/material';
import { ErrorIcon } from '@zeta-core/assets';

interface Props {
  open: boolean;
  message?: string;
}

const ErrorDialog = ({ open, message = '' }: Props) => {
  const theme = useTheme();
  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogContent sx={{ backgroundColor: alpha(theme.palette.error.main, 0.08) }}>
        <Stack gap={2} alignItems="center" px={2} py={5}>
          <ErrorIcon />
          <Typography variant="body2" sx={{ color: theme.palette.error.darker }}>
            {message ? message : 'Some Error occurred while saving the information.'}
          </Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ErrorDialog;
